<template>
    <div>
        <button
            class="wrap-sort row-padding-common pt16"
            @click="openSortModal"
            v-if="isInputActive == false"
        >
            <div class="text-sort">{{ $t(setSortName()) }}</div>
            <div class="img-sort"></div>
        </button>

        <div
            class="row-padding-common pt4"
            v-if="isInputActive == false && List.length > 0"
            v-for="(data, index) in List"
            :key="`${index}eventComment`"
        >
            <div class="wrap-comment column-padding-common">
                <div
                    v-if="data.Writer.mb_is_use === 0"
                    class="fz14 fw500 c4d"
                >{{$t('comment_event_delete')}}</div>
                <div v-else>
                    <div
                        v-if="data.Follow.block"
                        class="fz14 fw500 c4d"
                        v-html="$t('comment_event_block')"
                    ></div>
                    <div
                        v-else-if="data.Blind.status"
                        class="fz14 fw500 c4d"
                        v-html="$t('comment_event_report')"
                    ></div>
                    <div v-else>
                        <div class="comment-top pb8">
                            <div class="box-left">
                                <div
                                    class="img-left-profile mr8"
                                    :style="`background-image : url('${returnImg(data)}')`"
                                ></div>
                                <div
                                    class="text-left-profile"
                                >{{data.Writer.mb_nick}} · {{returnDateFormat(data.wr_datetime, 'YYYY.MM.DD') }}</div>
                            </div>
                            <button
                                class="text-right"
                                type="button"
                                v-if="UserInfo.mb_no !== data.Writer.mb_no"
                                @click="runReportConfirm(data.wr_id, data.Writer.mb_no)"
                            >{{ $t('report') }}</button>

                            <button
                                class="text-right img-close gray"
                                type="button"
                                v-else
                                @click="runDeleteConfirm(data.wr_id,{'wr_type':'post'})"
                            ></button>
                        </div>
                        <div class="text-comment">{{data.wr_content}}</div>
                    </div>
                </div>

                <div>
                    <div
                        class="row-padding-common pt4 pr10"
                        v-if="data.Comment.length > 0"
                        v-for="(replyData, index) in data.Comment"
                        :key="`${index}replyData`"
                    >
                        <div
                            v-if="replyData.Writer.mb_is_use === 0"
                            class="fz14 fw500 c4d"
                        >{{ $t('comment_event_delete') }}</div>
                        <div class="wrap-comment column-padding-common" v-else>
                            <div
                                v-if="replyData.Follow.block"
                                class="fz14 fw500 c4d"
                                v-html="$t('comment_event_block')"
                            ></div>
                            <div
                                v-else-if="replyData.Blind.status"
                                class="fz14 fw500 c4d"
                                v-html="$t('comment_event_report')"
                            ></div>
                            <div v-else>
                                <div class="comment-top pb8">
                                    <div class="box-left">
                                        <div class="img-elbow mr7"></div>
                                        <div
                                            class="img-left-profile mr8"
                                            :style="`background-image : url('${returnImg(replyData)}')`"
                                        ></div>
                                        <div
                                            class="text-left-profile"
                                        >{{replyData.Writer.mb_nick}} · {{replyData.wr_datetime}}</div>
                                    </div>
                                    <button
                                        class="text-right"
                                        type="button"
                                        v-if="UserInfo.mb_no !== replyData.Writer.mb_no"
                                        @click="runReportConfirm(replyData.wr_id, replyData.Writer.mb_no)"
                                    >{{ $t('report') }}</button>

                                    <button
                                        class="text-right img-close gray"
                                        type="button"
                                        v-else
                                        @click="runDeleteConfirm(replyData.wr_id,{'wr_type':'comment','wr_parent': data.wr_id})"
                                    ></button>
                                </div>
                                <div class="text-comment pl20 pb4">{{replyData.wr_content}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <event-comment-reply-write-component
                    v-if="isOwner"
                    :eventCommentKey="data.wr_id"
                    :eventKey="eventKey"
                    :isOwner="isOwner"
                ></event-comment-reply-write-component>
            </div>
        </div>

        <div v-else-if="isInputActive == false && List.length === 0">
            <div class="box-empty-home">
                <div class="title-empty-home" v-html="$t('empty_reviews')"></div>
            </div>
        </div>

        <pagination-link
            :paginationLayout="paginationLayout"
            :paginationData="filterSet.page"
            :listLength="List.length"
            :finishGetList="finishGetList"
        ></pagination-link>
    </div>
</template>

<script>
import eventUtil from "@/components/event/eventUtil";
import alertMixins from "@/mixins/alertMixins";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import PaginationLink from "@/components/utility/link/PaginationLink.vue";
import EventCommentReplyWriteComponent from "@/components/event/EventCommentReplyWriteComponent.vue";
import imageOption from "@/mixins/imageOption";
import { mapState } from "vuex";
import DeleteClass from "@/mixins/deleteClass";
import dateMixins from "@/mixins/dateMixins";

const { filterConfig } = eventUtil;
export default {
    name: "EventCommentListComponent",
    mixins: [
        alertMixins,
        filterMixins,
        listMixins,
        eventUtil,
        imageOption,
        dateMixins,
    ],
    components: {
        EventCommentReplyWriteComponent,
        PaginationLink,
    },
    inject: [],
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            setSort: this.setSort,
        };
    },
    props: {
        isReplyEditMode: false,
        eventKey: "",
        isInputActive: false,
        isOwner: false,
    },
    data() {
        return {
            getFunc: "getEventComment",
            listApiParamSet: {
                type: "post",

                ecmt: 1,
                wr: 1,
                cwr: 1,
                bli: 1,
                fl: 1,
                cfl: 1,
            },
            getKeyName: "eIdx",
            paginationLayout: "LazyloadDefaultLayout",
            isGetFirst: true,
            deleteFunc: "deleteEventComment",
            deleteApiParamsSet: {
                type: "post",
            },
            deleteSuccessType: 1,
            deleteFailTypes: {},
            DeleteClass: null,
            directType: "back",
            deleteKeyName: "wr_id",
            sortKeyName: "",
            sortOptions: {
                keyName: "obt",
                orderName: "obs",
            },
            isReply: false,
        };
    },
    beforeRouterEnter() {},
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig);
        this.setParserType("url", this.$route.fullPath);
        this.newDeleteClass();
    },
    mounted() {
        if (this.isGetFirst) {
            this.getList(true);
        } else {
            this.finishGetList = true;
        }

        EventBus.$on("setNticketSort", this.setCommentSort);
        EventBus.$on("getEventComment", this.getCommentList);
    },
    beforeUnmount() {
        
        // EventBus.$off('getEventComment');
        EventBus.$off("setNticketSort");
    },
    unmounted() {},
    computed: {
        ...mapState({
            UserInfo: (state) => state.userInfo.UserInfo,
        }),
    },
    methods: {
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },
        setSortName() {
            if (
                (util.isEmpty(this.filterSet) &&
                    util.isEmpty(this.filterSet.sort)) ||
                util.isEmpty(this.filterSet.sort.order)
            ) {
                return "sort_latest";
            } else if (this.filterSet.sort.order === "desc") {
                return "sort_latest";
            } else if (this.filterSet.sort.order === "asc") {
                return "sort_oldest";
            } else {
                return "sort_latest";
            }
        },

        runReportConfirm(key, userKey) {
            this.createConfirm({
                title: this.$t("blind_comment_title"),
                content: this.$t("blind_comment_content"),
                confirmText: this.$t("blind_only_comment"),
                cancelText: this.$t("blind_comment_and_user"),
                showCloseButton: true,
                confirm: () => {
                    this.runReport(key, null, false);
                },
                cancel: () => {
                    this.runReport(key, userKey, true);
                },
                close: () => {},
            });
        },

        async runReport(key, userKey, isBlockUser = false) {
            if (this.isRunning) {
                return false;
            }

            this.isRunning = true;
            let params = {
                wr_id: key,
            };
            try {
                this.$api.$board["reportEventComment"](params)
                    .then((res) => res.Data.Result)
                    .then((res) => {
                        if (!res.Info.status) {
                            EventBus.$emit("apiLoading", false);
                            this.errorAlert(this.$t("fail_report_reply"));
                            return false;
                        } else {
                            if (isBlockUser) {
                                this.runBlockUser(userKey);
                            } else {
                                this.isRunning = false;
                                this.reportAfterFunc();
                            }
                        }
                    });
            } catch (e) {
                EventBus.$emit("apiLoading", false);
                this.isRunning = false;
                console.log(e);
            }
        },
        async runBlockUser(userKey) {
            let params = {
                follow_id: userKey,
            };
            try {
                this.$api.$member["toggleBlock"](params)
                    .then((res) => res.Data.Result)
                    .then((res) => {
                        if (!res.Info.status) {
                            EventBus.$emit("apiLoading", false);
                            this.errorAlert(this.$t("fail_block_user"));
                            return false;
                        } else {
                            this.isRunning = false;
                            this.reportAfterFunc();
                        }
                    });
            } catch (e) {
                EventBus.$emit("apiLoading", false);
                this.isRunning = false;
                console.log(e);
            }
        },

        reportAfterFunc() {
            EventBus.$emit("apiLoading", false);
            showDefaultToast(this.$t("report_complete"));
            EventBus.$emit("getEventComment");
        },
        runDelete(key, moreParams = {}) {
            EventBus.$emit("apiLoading", true);
            this.DeleteClass.runDelete(key, moreParams);
        },

        runDeleteConfirm(key, moreParams = {}, isReply = false) {
            this.isReply = isReply;
            let title = isReply
                ? "confirm_delete_comment_reply"
                : "confirm_delete_comment";
            this.createCustomConfirm({
                title: this.$t(title),
                content: this.$t("delete_board"),
                confirm: () => {
                    this.runDelete(key, moreParams);
                },
            });
        },

        openSortModal() {
            this.$modal.show("non-button-sort-modal", this.filterSet.sort);
        },
        setCommentSort(data) {
            this.setSort("wr.created_at", data.order);
        },
        returnImg(data) {
            if (
                !util.isEmpty(data.Writer) &&
                !util.isEmpty(data.Writer.Profile[0]) &&
                !util.isEmpty(data.Writer.Profile[0].a_idx)
            ) {
                return `${
                    data.Writer.Profile[0].org_url
                }?${this.setImageOptions(null, null)}`;
            } else {
                return "";
            }
        },
        getCommentList() {
            this.getList(true);
        },
        initConfig() {
            let params = this.listApiParamSet;

            if (!util.isEmpty(this.getKeyName)) {
                params[this.getKeyName] = this.eventKey;
            }
            this.setSortOptions(this.sortOptions);
            let listOptions = {
                url: this.$api.$board[this.getFunc],
                defaultParams: params,
            };
            this.initList("api", listOptions);
        },

        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$board[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.deleteKeyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                };
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },

        deleteAfterFunc() {
            EventBus.$emit("apiLoading", false);
            showDefaultToast(this.$t("del"));
            EventBus.$emit("getEventComment");
        },
        updateAlert() {
            this.createConfirm({
                title: this.$t("btn_redirect_to_purchase_page_web"),
                content: this.$t("content_launch_web_create"),
                confirm: () => {},
                cancel: () => {},
            });
        },
    },
    watch: {},
};
</script>

<style scoped>
</style>
